const checkFormCompleteForCreateLocation = (locationState) => {
  let isFormComplete =
    locationState.locationName.length >= 5 &&
    locationState.locationName.length <= 50 &&
    locationState.locationStreetAddress1.length > 0 &&
    locationState.locationStreetAddress1.length <= 255 &&
    //TODO: revisit country subdivision
    //locationState.countrySubdivision.id &&
    locationState.country.id &&
    ((locationState.locationCity.length > 0 && locationState.locationCity.length <= 50) ||
      locationState.locationPostalCode.length > 0);

  locationState.realEstateInterestList.forEach((rei) => {
    if (
      rei.realEstateInterestDesc.length > 250 ||
      rei.realEstateInterestName.length < 5 ||
      rei.realEstateInterestName.length > 100 ||
      rei.realEstateInterestTypeId === '' ||
      rei.isREILocked
    ) {
      return isFormComplete = false;
    } else {
      rei.realEstateInterestSourceSystemRelate.forEach((reiSource) => {
        if (
          !reiSource.realEstateInterestSourceSystemId ||
          !reiSource.realEstateInterestSourceSystemTypeId ||
          !reiSource.realEstateInterestSourceSystemReferenceID
        ) {
          return isFormComplete = false;
        }
      });
    }
  });

  return isFormComplete;
};

const checkFormCompleteForLocationDetails = (locationState) => {
  let isFormComplete = true;
  let retailParentId = 8;
  isFormComplete =
    locationState.primaryUseType.id &&
    locationState.locationOperationStatus.id &&
    (locationState.primaryUseType.parentId === retailParentId
      ? locationState.storeBrand.id && locationState.fuelBrand.id
      : true);

  locationState.stewardshipCostObjectList.forEach((sco) => {
    if (!sco.costObjectTypeId || !sco.stewardshipTypeId || !sco.costObject) {
      return isFormComplete = false;
    }
  });

  if (locationState.sourceSystemLinkList.find((source) =>
    source.isSourceSystemValid === false
  )) {
    return isFormComplete = false;
  }

  if (locationState.isCheckedConnexion) {
    if (locationState.sourceSystemLinkList.length === 0) {
      return isFormComplete = false;
    } else {
      let existingSapCode = locationState.sourceSystemLinkList.find((source) =>
        source.sourceSystemName.toLowerCase() === 'connexion' &&
        source.sourceSystemIdTypeName.toLowerCase() === 'sap_location_code' &&
        source.sourceSystemIdTypeId !== ''
      )
      if (!existingSapCode) {
        return isFormComplete = false;
      }
    }
  }

  locationState.sourceSystemLinkList.forEach((locationSource) => {
    if (
      (
        !locationSource.sourceSystemId ||
        !locationSource.sourceSystemIdTypeId ||
        !locationSource.sourceSystemReferenceId
      ) && locationState.isCheckedConnexion
    ) {
      return (isFormComplete = false);
    }
  });
  return isFormComplete;
};

const checkFormCompleteForBusinessLine = (locationState) => {
  let totalBusinessLinePercentAllocation = 0;
  let totalEpsBusinessLinePercentAllocation = 0;
  let acceptedPercentages = new Array(0, 100);
  let isFormComplete = true;
  locationState.businessLineAllocationList.forEach((businessLineAllocation) => {
    totalBusinessLinePercentAllocation += parseFloat(
      businessLineAllocation.allocationPercent
    );
  });

  locationState.epsBusinessLineAllocationList.forEach((epsBusinessLineAllocation) => {
    totalEpsBusinessLinePercentAllocation += parseFloat(
      epsBusinessLineAllocation.epsAllocationPercent
    );
  });
  if (
    !acceptedPercentages.includes(totalBusinessLinePercentAllocation) ||
    !acceptedPercentages.includes(totalEpsBusinessLinePercentAllocation)
  ) {
    return isFormComplete = false;
  }

  if (totalBusinessLinePercentAllocation === 100) {
    locationState.businessLineAllocationList.forEach((businessLineAllocation) => {
      if (
        !businessLineAllocation.businessLineReportUnitCompanyCode ||
        !businessLineAllocation.businessLineCode
      ) {
        return isFormComplete = false;
      }
    });
  }

  if (totalEpsBusinessLinePercentAllocation === 100) {
    locationState.epsBusinessLineAllocationList.forEach((epsBusinessLineAllocation) => {
      if (
        !epsBusinessLineAllocation.eps_business_vc_id ||
        !epsBusinessLineAllocation.eps_business_line_id
      ) {
        return isFormComplete = false;
      }
    });
  }
  return isFormComplete;
};

const checkFormCompleteForSite = (locationState) => {
  let isFormComplete =
    locationState.siteName.length >= 5 &&
    locationState.siteName.length <= 50 &&
    locationState.siteCode.length > 0 &&
    locationState.siteCode.length <= 20 &&
    (!locationState.siteId || locationState.siteCountryId === locationState.country?.id) &&
    locationState.siteOperationStatus &&
    locationState.sitePrimaryUseType;

  locationState.itSiteCodeList.forEach((itSiteCode) => {
    if (!itSiteCode.itSiteCodeId) {
      return isFormComplete = false;
    }
  });

  locationState.siteSourceLinkList.forEach((siteSource) => {
    if (
      !siteSource.sourceSystemId ||
      !siteSource.sourceSystemIdTypeId ||
      !siteSource.sourceSystemReferenceId ||
      siteSource.isSourceSystemValid === false
    ) {
      return isFormComplete = false;
    }
  });

  return isFormComplete;
};

const checkFormCompleteForBuilding = (locationState) => {
let isFormComplete = true;

if (locationState.buildingList) {
  locationState.buildingList.forEach((building) => {
    if (building.sourceSystemReferenceId) {
      if (!building.isNuvoloBuildingValid) {
        return isFormComplete = false;
      }
      if (!building.buildingName) {
        return isFormComplete = false;
      }
    }
  });
}

return isFormComplete;
};

export default {
  checkFormCompleteForCreateLocation,
  checkFormCompleteForLocationDetails,
  checkFormCompleteForBusinessLine,
  checkFormCompleteForSite,
  checkFormCompleteForBuilding,
};
